import { render, staticRenderFns } from "./SectionNearby.vue?vue&type=template&id=9c5e8312&scoped=true"
import script from "./SectionNearby.vue?vue&type=script&lang=ts"
export * from "./SectionNearby.vue?vue&type=script&lang=ts"
import style0 from "./SectionNearby.vue?vue&type=style&index=0&id=9c5e8312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5e8312",
  null
  
)

export default component.exports